import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const SvgContainer = styled.svg`
  width: ${props => (props.size ? props.size + "px" : "20px")};
  height: ${props => (props.size ? props.size + "px" : "20px")};
  margin-right: -2px;
  path {
    fill: ${props => (props.color ? props.color : Variables.colors.complementary_700)} !important;
    stroke: ${props => (props.color ? props.color : Variables.colors.complementary_700)} !important;
  }
`;
